module.exports = __webpack_public_path__ + "img/vip-crowd_cclub.28b687cb.webp";